import React from "react";
import { useParentSize } from "@visx/responsive";

// O kit desenha com uma largura em pixels, e isto da-lha a partir do contentor. O div tem a altura do
// grafico e overflow normal porque o ParentSize do visx 4 mede dentro de uma caixa absoluta com
// overflow hidden, que corta o grafico e as tooltips. Os testes do kit passam `width` diretamente aos
// graficos: o jsdom nao mede nada.
const ResponsiveChart = ({ height, children }) => {
  const { parentRef, width } = useParentSize({ debounceTime: 50, ignoreDimensions: "height" });
  return (
    <div ref={parentRef} style={{ height }}>
      {width > 0 && children(width)}
    </div>
  );
};

export default ResponsiveChart;
